import { useQuery } from '@tanstack/react-query';
import {
  gqlClient,
  graphql,
  Notes_TagCategory,
  type QueryAdditionalOptions,
  queryClient,
  type UseQueryReturnType,
} from '@tyro/api';
import { peopleKeys } from '../keys';

// Reset tag is hardcoded on the backend and hidden from staff in the UI.
const RESET_TAG_ID = 3654;

export type ReturnTypeFromUseNoteTagsBehaviour = UseQueryReturnType<
  typeof useNoteTagsBehaviour
>[number];

const noteTagsBehaviour = graphql(/* GraphQL */ `
  query notes_tags_behaviours($filter: Notes_TagFilter!) {
    notes_tags(filter: $filter) {
      id
      name
      description
      behaviourType
      tag_l2
      category
      behaviourCategory {
        behaviourCategoryId
        name
      }
      points
      availableToContacts
      availableToStaff
      availableToStudents
    }
  }
`);

const noteTagsBehaviourQuery = () => ({
  queryKey: peopleKeys.notes.behaviourTags(),
  queryFn: async () => {
    const { notes_tags: tags } = await gqlClient.request(noteTagsBehaviour, {
      filter: {
        categories: [Notes_TagCategory.Behaviour],
      },
    });

    return tags
      .filter((tag) => tag.id !== RESET_TAG_ID)
      .sort((prev, next) => prev.name.localeCompare(next.name));
  },
});

export function getNoteTagsBehaviour() {
  return queryClient.fetchQuery(noteTagsBehaviourQuery());
}

export function useNoteTagsBehaviour(
  additionalOptions?: Omit<QueryAdditionalOptions, 'academicNamespaceId'>,
) {
  return useQuery({
    ...noteTagsBehaviourQuery(),
    select: (tags) => tags,
    ...additionalOptions,
  });
}
